import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';
import MainApp from './main-app';
import { PrimeReactProvider } from 'primereact/api';
import { ThemeProvider } from './services/contexts/theme-context';  // Use theme context
import ErrorBoundary from './components/error-boundary';
// Global CSS Imports
import 'primeflex/primeflex.css';  
import 'primeicons/primeicons.css';
import { ToastProvider } from './services/contexts/toast-context';


export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: false,
      staleTime: 0,
    },
  },
});

function App() {
  const value = { ripple: true };

  return (
    <div className="App">
      <ErrorBoundary>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <PrimeReactProvider value={value}>
              <ToastProvider>
                <MainApp />
              </ToastProvider>
            </PrimeReactProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
